// Simple plugin to expose global window.config via this.$config without making it reactive.
// This avoids repeated imports / direct window access and keeps a single indirection point.
export default {
  install(Vue) {
    if (Vue.prototype.$config) return; // avoid re-install
    /** @type {typeof window.config} */
    Object.defineProperty(Vue.prototype, '$config', {
      get() {
        return typeof window !== 'undefined' ? window.config : undefined;
      },
    });
  }
};

